;(function (RelatedProductsSlider, $) {

  let $dom = {};

  const sliderOptions = {
    mobileFirst: true,
    nextArrow: '<div class="owl-next slick-arrow"></div>',
    prevArrow: '<div class="owl-prev slick-arrow"></div>',
    responsive: [{
      breakpoint: 992,
      settings: "unslick"
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      }
    }]
  };

  const cacheDom = () => {
    $dom.relatedProductsSlider = $('[data-slider="related-products-slider"]');
  };

  const initSliders = () => {
    $dom.relatedProductsSlider.on('destroy', function (event, slick) {
      let carousel = $(this);
      let reinit = Debounce.wait(function () {
        if (slick.activeBreakpoint < window.innerWidth) {
          return;
        }
        carousel.addClass('is-slick-activated').removeClass('is-slick-destroyed');
        carousel.slick(slick.options);
        window.removeEventListener(reinit);
      }, 500);
      carousel.addClass('is-slick-destroyed').removeClass('is-slick-activated');
      window.addEventListener('resize', reinit);
    }).slick(sliderOptions);
  };

  RelatedProductsSlider.init = function () {
    cacheDom();
    initSliders();
  };

})(window.RelatedProductsSlider = window.RelatedProductsSlider || {}, jQuery);
